import { Dispatch, SetStateAction, useCallback } from 'react';
import { EditUnitFormType } from '@mark43/cad-api';
import { useWatch } from 'react-hook-form';
import { FormNumberInput } from '../../forms/integrated-form-controls/form-number-input';
import { useIntegratedForm } from '../../forms/use-integrated-form';

export function StaffCountInput({
    setUserChangedStaffCount,
}: {
    setUserChangedStaffCount?: Dispatch<SetStateAction<boolean>>;
}): React.ReactElement {
    const { form } = useIntegratedForm<EditUnitFormType>();
    const callSignValue = useWatch({ control: form.control, name: 'callSign' });

    const handleChange = useCallback(() => {
        setUserChangedStaffCount?.(true);
    }, [setUserChangedStaffCount]);

    return (
        <FormNumberInput
            name="staffCount"
            control={form.control}
            label="Staff Count"
            isDisabled={!callSignValue}
            length="auto"
            onChange={handleChange}
        />
    );
}
